export const capitalize = (value: string) => {
  if (!value.length) { return value; }

  return `${value.slice(0,1).toUpperCase()}${value.slice(1)}`;
}